import React from 'react';

const ActiveEnvironment = () => {
    const environment = process.env.NODE_ENV || 'Could Not Find';
    const backendApi = process.env.REACT_APP_API_URL || 'Could Not Find';

    return (
        <div style={styles.container}>
            <h2 style={styles.heading}>Active React Environment</h2>
            <div style={styles.infoBox}>
                <p style={styles.infoText}><strong>NODE_ENV:</strong> {environment}</p>
                <p style={styles.infoText}><strong>Backend API:</strong> {backendApi}</p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        padding: '1.5rem',
        backgroundColor: '#fff',
        borderRadius: '1rem',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        margin: '2rem auto',
        fontFamily: 'Arial, sans-serif',
        textAlign: 'center',
        transition: 'transform 0.2s',
    },
    heading: {
        fontSize: '1.5rem',
        fontWeight: '600',
        marginBottom: '1rem',
        color: '#333',
    },
    infoBox: {
        backgroundColor: '#f9f9f9',
        padding: '1rem',
        borderRadius: '0.75rem',
        boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.05)',
    },
    infoText: {
        fontSize: '1rem',
        margin: '0.5rem 0',
        color: '#555',
    }
};

export default ActiveEnvironment;
